import { PermissionT } from "../types";

export const previewUser = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "preview_user");
  return !!p;
};

export default previewUser;
